import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AddAdmin from './AddAdmin'

class ParselAddAdmin extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AddAdmin} {...props}/>
   )
 }
}



export default ParselAddAdmin;
